module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }